import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ItemProduto } from 'src/app/admihair/api/dto/item-produto';
import { SaidaEstoqueService } from 'src/app/admihair/service/saida-estoque.service';
import { SaidaEstoque } from 'src/app/admihair/api/dto/saida-estoque';
import { Table } from 'primeng/table';
import { NgForm } from '@angular/forms';
import { ItemProdutoService } from 'src/app/admihair/service/item-produto.service';
import { Profissional } from 'src/app/admihair/api/dto/profissional';
import { ProfissionalService } from 'src/app/admihair/service/profissional.service';
import { Paginador } from 'src/app/admihair/api/dto/paginacao/paginador';

@Component({
  selector: 'app-saida-estoque-inserir',
  templateUrl: './saida-estoque-inserir.component.html',
  styleUrls: ['./saida-estoque-inserir.component.scss']
})
export class SaidaEstoqueInserirComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild('f') form?: NgForm;
  @ViewChild('filter') filter!: ElementRef;
  progressoRequisicao: boolean = false;
  dataSelecionada: Date = new Date();

  loadingTableItens: boolean = false;
  exibirDialogProduto: boolean = false;
  exibirSpinnerDialog: boolean = false;
  listaProdutosDialog: ItemProduto[] = [];
  itensProdutosPaginados?: Paginador<ItemProduto>;
  numeroPaginaProduto: number = 0;

  produtoSelecionado?: ItemProduto;
  descricaoProdutoSelecionado: string = 'Selecione';
  quantidadeInformada: number = 0;

  exibirDialogAtendente: boolean = false;
  exibirSpinnerDialogAtendente: boolean = false;
  listaAtendentes: Profissional[] = [];
  atendenteSelecionado?: Profissional;
  nomeAtendenteSelecionado: string = 'Selecione';

  inputBusca: string = '';

  constructor(private saidaEstoqueService: SaidaEstoqueService,
    private itemProdutoService: ItemProdutoService,
    private profissionalService: ProfissionalService,
    erroService: ErroService,
    storageService: UtilStorageService,
    router: Router,
    activatedRoute: ActivatedRoute
  ) {
    super(erroService, storageService, router, activatedRoute)
  }

  ngOnInit(): void {
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_SAIDA_ESTOQUE');
  }

  salvar() {
    this.progressoRequisicao = true;
    const saidaProduto: SaidaEstoque = {
      data: this.dataSelecionada,
      item: this.produtoSelecionado,
      quantidade: this.quantidadeInformada,
      profissionalId: this.atendenteSelecionado?.id,
      empresaId: this.getEmpresa().id,
      usuario: this.getUsuarioLogadoSistema().id
    }

    this.saidaEstoqueService.salvar(saidaProduto).subscribe({
      next: (data: SaidaEstoque) => {
        this.progressoRequisicao = false;
        this.exibirMensagemSucesso();
        this.limparFormulario();
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.exibirMensagemErro(err)
      }
    })

  }

  limparFormulario() {
    this.produtoSelecionado = undefined;
    this.descricaoProdutoSelecionado = '';
    this.quantidadeInformada = 0;
    this.atendenteSelecionado = undefined;
    this.nomeAtendenteSelecionado = '';
  }

  fecharDialogProduto() {
    this.exibirSpinnerDialog = false;
    this.exibirDialogProduto = false;
  }

  abrirDialogProduto() {
    this.exibirDialogProduto = true;
    this.exibirSpinnerDialog = true;
    this.carregarItensProdutos(0);
  }

  carregarItensProdutos(numeroPagina?: number) {
    const tamanhoPagina = 5;
    console.log(this.inputBusca)
    this.itemProdutoService
      .listarProdutoBaixaPorEmpresaPaginado(this.getEmpresa().id, numeroPagina, tamanhoPagina, this.inputBusca).subscribe({
        next: (data: Paginador<ItemProduto>) => {
          this.listaProdutosDialog = data.content;
          this.itensProdutosPaginados = data;
          this.exibirSpinnerDialog = false;
          this.loadingTableItens = false;
        },
        error: (err: any) => {
          this.exibirSpinnerDialog = false;
          this.loadingTableItens = false;
          this.exibirDialogProduto = false;
          this.exibirMensagemErro(err);
        }
      })
  }

  selecionarItem(item: ItemProduto) {
    this.produtoSelecionado = item;
    this.descricaoProdutoSelecionado = item.descricao ?? '';
    this.exibirDialogProduto = false;
  }

  buscarDialogItens(event: Event) {
    this.loadingTableItens = true;
    this.inputBusca = (event.target as HTMLInputElement).value;
    this.carregarItensProdutos(0);
  }

  limparDialogItens() {
    this.loadingTableItens = true;
    this.filter.nativeElement.value = '';
    this.inputBusca = '';
    this.carregarItensProdutos(0);
  }

  onPageChangeProdutos(event: any) {
    this.loadingTableItens = true;
    if (this.itensProdutosPaginados) {
      this.numeroPaginaProduto = event.first / event.rows;
    }
    this.carregarItensProdutos(this.numeroPaginaProduto);
  }

  abrirDialogAtendente() {
    this.exibirDialogAtendente = true;
    this.exibirSpinnerDialogAtendente = true;
    this.carregarAtendentes();
  }

  carregarAtendentes() {
    this.profissionalService.listarAtivosPorEmpresaId(this.getEmpresa().id).subscribe({
      next: (data: Profissional[]) => {
        this.listaAtendentes = data;
        this.exibirSpinnerDialogAtendente = false;
      },
      error: (err: any) => {
        this.exibirSpinnerDialogAtendente = false;
        this.exibirDialogAtendente = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  selecionarAtendente(atendente: Profissional) {
    this.atendenteSelecionado = atendente;
    this.nomeAtendenteSelecionado = atendente.nomeProfissional ?? '';
    this.exibirDialogAtendente = false;
  }

  fecharDialogAtendente() {
    this.exibirSpinnerDialogAtendente = false;
    this.exibirDialogAtendente = false;
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

}
